import {Box, FileLink, Typography} from 'web-library';
import {AnnouncementDetail} from 'web-library/models/Announcements';
import React from 'react';
import {makeStyles} from 'tss-react/mui';
import parse from 'html-react-parser';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles()((theme) => ({
  titleContainer: {
    color: theme.color.text.textPrimary,
    marginBottom: theme.spacing(1),
  },
  descriptionContainer: {
    fontWeight: 400,
    marginBottom: theme.spacing(4),
  },
  fileContainer: {
    marginBottom: theme.spacing(3),
  },
}));

interface AnnouncementSingleContentProps {
  announcementNoticeDetails: AnnouncementDetail;
}

const PaymentContent = ({
                          announcementNoticeDetails,
                        }: AnnouncementSingleContentProps) => {
  const {t} = useTranslation();
  const {classes} = useStyles();

  return (
      <>
        {announcementNoticeDetails?.title && (
            <Typography variant="h4" className={classes.titleContainer}>
              {announcementNoticeDetails?.title}
            </Typography>
        )}
        {announcementNoticeDetails?.description && (
            <Typography variant="body1" className={classes.descriptionContainer}>
              {parse(announcementNoticeDetails?.description || '')}
            </Typography>
        )}
        {announcementNoticeDetails?.files && (
            <Box className={classes.fileContainer}>
              {announcementNoticeDetails.files.map((fileInfo) => (
                  <FileLink key={fileInfo.url} fileInfo={fileInfo}/>
              ))}
            </Box>
        )}
      </>
  );
};

export default PaymentContent;
